export default {
  PORT_URL: "https://vast-eyrie-10587.herokuapp.com"
};
